import type { StudyAuthoringRecord } from '@testfeed/shopify-contracts'
import { insightOpportunityCopy as copy } from '@testfeed/product-language'
import { InsightOpportunityResearch } from '../insights/InsightOpportunityResearch'

/** Saved, server-permitted original proposal; edits in the form do not rewrite its source claims. */
export function StudyBuilderResearch({
  proposal,
}: {
  proposal: NonNullable<StudyAuthoringRecord['draft']['insightSetupSeed']>['initialProposal']
}) {
  if (!proposal || proposal.status !== 'ready' || !proposal.research || proposal.research.status === 'not_requested')
    return null
  return (
    <s-section heading={copy.researchOriginal}>
      <s-stack gap="base">
        <s-paragraph>{proposal.choice.pick.reason}</s-paragraph>
        {proposal.alternatives.map((alternative) => (
          <s-stack key={alternative.id} gap="small-100">
            <s-text fontWeight="semibold">{alternative.title}</s-text>
            <s-paragraph>{alternative.value}</s-paragraph>
          </s-stack>
        ))}
        <InsightOpportunityResearch research={proposal.research} />
      </s-stack>
    </s-section>
  )
}
